import { render, staticRenderFns } from "./ListTab.vue?vue&type=template&id=2e4a669d&scoped=true&lang=pug&"
import script from "./ListTab.vue?vue&type=script&lang=js&"
export * from "./ListTab.vue?vue&type=script&lang=js&"
import style0 from "./ListTab.vue?vue&type=style&index=0&id=2e4a669d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4a669d",
  null
  
)

export default component.exports